// extracted by mini-css-extract-plugin
export var container = "_cz-0";
export var popoverContent = "_cz-1";
export var tosLink = "_cz-2";